import aboutCardIcon1 from "../../images/logo.png"
import aboutCardIcon2 from "../../images/partners/nft-crypto.png"
import aboutCardIcon3 from "../../images/partners/y5-trader.webp"

 const data = {
    aboutDescription1: 'The ALPHA OCTOPUS is a collection of 1000 unique digital collectibles living on the Ethereum blockchain.Your ALPHA OCTOPUS will double up as a membership to the exclusive ALPHA OCTOPUS club where owners will be rewarded with perks and benefits. Not to mention the charitable causes associated with this project and its Amazing roadmap.',
    aboutDescription2: "ALPHA OCTOPUS inspired by Lorde's Creation of Greatness where every successful person has to become like a ALPHA OCTOPUS to achieve Success. Many hands or tentacles make light work being able to multi-task. Each NFT has unique traits with special utilities.",
    aboutDescription2: "So Pick up your ALPHA OCTOPUS and Join the very exclusive Club NOW !",
    aboutInfo: [
        {
            icon: aboutCardIcon1,
            title: "Collectible Opportunity",
            text: "Each unique ALPHA OCTOPUS NFT is a collectable which increases as an asset with the fixability to trade with utilities to back your investment with real life opportunities. "
        },
        {
            icon: aboutCardIcon2,
            title: "Future With US",
            text: 'The future of ALPHA OCTOPUS is Infinitely great as each collection mints and sells the community grows with artistic and creative developments from 3D to the metaverse.'
        },
        {
            icon: aboutCardIcon3,
            title: "Connect with Y5",
            text: 'Y5 is the world’s first crypto wealth token, building limitless utilities with real-world value to drive profits directly into the holders of our wealth token.'
        }
    ]
}

export default data;